import { useFormik } from "formik";
import * as Yup from "yup";
import apiRequest from "../../../utils/vendorManager/apiRequest";
import InputField from "../../ui/form/InputField";
import Button from "../../ui/utils/Button";
import CheckboxField from "../../ui/form/CheckboxField";
import SelectField from "../../ui/form/SelectField";
import usePost from "../../../hooks/api/usePost";
import Alert from "../../ui/utils/Alert";
import useFetch from "../../../hooks/api/useFetch";

const CreateProduct = ({ closeModal, callback }) => {
    const {
        error,
        isLoading: loading,
        post,
        serverErrors,
    } = usePost(apiRequest.createProduct);

    const formik = useFormik({
        initialValues: {
            name: "",
            itemNo: "",
            description: "",
            food_type: "VEG",
            itemCategory: "",
            mainCategory: "",
            vendorPrice: 0,
            gstAmount: 0,
            sgstAmount: 0,
            finalPrice: 0,
            quantity: 1,
            status: true,
        },

        validationSchema: Yup.object({
            name: Yup.string().required("Product name is required"),
            itemNo: Yup.string().required("Item No is required"),
            food_type: Yup.string().required("Food type is required"),
            vendorPrice: Yup.number()
                .typeError("Must be a number")
                .required("Vendor price is required"),
            finalPrice: Yup.number()
                .typeError("Must be a number")
                .required("Final price is required"),

        }),

        onSubmit: async (values, { resetForm }) => {
            const response = await post({ data: { body: values } });
            if (response?.response) {
                callback?.();
                resetForm();
                closeModal();
            }
        },
    });


    const { data: categoryOptions } = useFetch({
        apiMethod: apiRequest.getMainCategory,
        body: { paginate: false, sortField: "name", sortOrder: "asc" },
    });
  
    


    return (
        <div>
            <h2 className="p-4 text-lg font-semibold">Create Product</h2>
            <div className="border-b" />

            <form onSubmit={formik.handleSubmit} className="text-sm">
                {error && <Alert message={error} type="error" />}

                <div className="grid grid-cols-1 gap-2 p-4 sm:grid-cols-2">
                    <InputField
                        name="name"
                        label="Product Name"
                        placeholder="Enter product name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        serverError={serverErrors?.name}
                        error={formik.touched.name && formik.errors.name}
                    />

                    <InputField
                        name="itemNo"
                        label="Item No"
                        placeholder="Enter item number"
                        value={formik.values.itemNo}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        serverError={serverErrors?.itemNo}
                        error={formik.touched.itemNo && formik.errors.itemNo}
                    />

                    <SelectField
                        name="food_type"
                        label="Food Type"
                        value={formik.values.food_type}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        serverError={serverErrors?.food_type}
                        error={formik.touched.food_type && formik.errors.food_type}
                        options={[
                            { label: "Veg", value: "VEG" },
                            { label: "Non-Veg", value: "NONVEG" },
                        ]}
                    />

                    <SelectField
                        name="mainCategory"
                        label="Main Category"
                        placeholder="e.g. Snacks"
                        value={formik.values.mainCategory}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        serverError={serverErrors?.mainCategory}
                        error={formik.touched.mainCategory && formik.errors.mainCategory}
                        options={categoryOptions?.map((c) => ({
                            value: c._id,
                            label: c.name,
                        }))}
                    />

                    <InputField
                        name="itemCategory"
                        label="Item Category"
                        placeholder="e.g. Snacks"
                        value={formik.values.itemCategory}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        serverError={serverErrors?.itemCategory}
                        error={formik.touched.itemCategory && formik.errors.itemCategory}
                    />


                    <InputField
                        type="number"
                        name="finalPrice"
                        label="Final Price"
                        value={formik.values.finalPrice}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        serverError={serverErrors?.finalPrice}
                        error={formik.touched.finalPrice && formik.errors.finalPrice}
                    />



                </div>

                <div className="border-b" />
                <div className="flex justify-end gap-2 p-4">
                    <Button variant="secondary" onClick={closeModal}>
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        variant="primary"
                        loadingText="Creating..."
                        isLoading={loading}
                    >
                        Create
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default CreateProduct;
